import { isRequired, minLength, maxLength } from 'utils/validate/validate';
import { ENUM_TIPO_PESSOA, MSG_CAMPO_INVALIDO } from 'utils/consts';

export const validationsPessoaCreate = (dadosInputs, dadosCadastrais = false) => {
  const { tipoPessoa, nome, cpf, email, enderecoPf, enderecoPj, razaoSocial, cnpj, telefone } = dadosInputs;

  let errosCampos = {
    // DADOS PESSOAIS
    tipoPessoa: isRequired(tipoPessoa),
    nome: isRequired(nome),
    cpf: isRequired(cpf) || minLength(cpf, 14) || maxLength(cpf, 14),
    email: isRequired(email),
  };
  // ENDEREÇO
  if (dadosCadastrais) {
    if (tipoPessoa === ENUM_TIPO_PESSOA.fisica.descricao)
      errosCampos = {
        ...errosCampos,
        'enderecoPf.cep': isRequired(enderecoPf.cep) || minLength(enderecoPf.cep, 9) || maxLength(enderecoPf.cep, 9),
        'enderecoPf.logradouro': isRequired(enderecoPf.logradouro),
        'enderecoPf.numero': isRequired(enderecoPf.numero),
        'enderecoPf.bairro': isRequired(enderecoPf.bairro),
        'enderecoPf.cidade': isRequired(enderecoPf.cidade),
        'enderecoPf.estado': isRequired(enderecoPf.estado),
        'enderecoPf.pais': isRequired(enderecoPf.pais),
      };
  } else {
    errosCampos = {
      ...errosCampos,
      cep: isRequired(dadosInputs?.cep) || minLength(dadosInputs?.cep, 9) || maxLength(dadosInputs?.cep, 9),
      logradouro: isRequired(dadosInputs?.logradouro),
      numero: isRequired(dadosInputs?.numero),
      bairro: isRequired(dadosInputs?.bairro),
      cidade: isRequired(dadosInputs?.cidade),
      estado: isRequired(dadosInputs?.estado),
      pais: isRequired(dadosInputs?.pais),
    };
  }

  // PESSOA JURIDICA
  if (tipoPessoa === ENUM_TIPO_PESSOA.juridica.descricao) {
    errosCampos.razaoSocial = isRequired(razaoSocial);
    errosCampos.cnpj = isRequired(cnpj) || minLength(cnpj, 18) || maxLength(cnpj, 18);
    if (dadosCadastrais) {
      errosCampos = {
        ...errosCampos,
        'enderecoPj.cep': isRequired(enderecoPj.cep) || minLength(enderecoPj.cep, 9) || maxLength(enderecoPj.cep, 9),
        'enderecoPj.logradouro': isRequired(enderecoPj.logradouro),
        'enderecoPj.numero': isRequired(enderecoPj.numero),
        'enderecoPj.bairro': isRequired(enderecoPj.bairro),
        'enderecoPj.cidade': isRequired(enderecoPj.cidade),
        'enderecoPj.estado': isRequired(enderecoPj.estado),
        'enderecoPj.pais': isRequired(enderecoPj.pais),
      };
    }
  }

  if (telefone?.length > 0 && telefone?.length < 14) errosCampos.telefone = MSG_CAMPO_INVALIDO;

  return errosCampos;
};
